module.exports = __webpack_public_path__ + "images/emoji/frowning.4fdf340ef782d4a2ad61.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/frowning.png
// module id = Mpwo
// module chunks = 13